export default __webpack_public_path__ + "static/media/QuoteClose.7d5abdc7.svg";